import React from "react";
import Select from "components/select/select";
import SocialSelect from "components/settings/component/SocialSelect";
import { profileStyles, profileTypes } from "utils/constant";
import PopInfo from "components/info-popup/pop-info";
import WebsiteSelect from "components/settings/component/WebsiteSelect";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import update from "immutability-helper";



export default function SocialMediaForm({
  state,
  socials = [],
  onAddSocials = () => {},
  onTypeLinkSocial = () => {},
  onSelectSocial = () => {},
  onRemoveSocials = () => {},
  handleInputChange = () => {},
  websites = [],
  setWebsites = ()=>{}
}) {
  const {t} = useTranslation();

  const onLabelChange = (e, index, media_type) => {
      console.log(e.target.value, index);
      if(media_type === "website") {
        const payload =  _.clone(websites);
        payload[index].label = e.target.value;
    
        setWebsites(payload);
      }
    };

  const checkUrl = (e, index, media_type) => {
      if (
        !e.target.value.includes("https://") &&
        !e.target.value.includes("http://")
      ) {
  
        if(_.isEmpty(e.target.value)){
          return;
        } 
        let addProtocol = `https://${e.target.value}`;
        let payload = [];
        if (media_type === "social") {
          payload = _.clone(socials);
        } else if (media_type === "website") {
          payload = _.clone(websites);
        }
  
        let result = update(payload, {
          [index]: {
            link: { $set: addProtocol },
          },
        }); //remove
  
        console.log(`result[${index}].label`, result[index].label);
        if(!result[index].label && media_type === "website") {
          const linkLabel = new URL(addProtocol).hostname?.replace(/^www\./gi, "").split(".")[0];
          result[index].label = linkLabel;
        }
  
        // if (media_type === "social") {
        //   setSocials(result);
        // } else if (media_type === "website") {
          setWebsites(result);
        // }
      } else {
        if(media_type === "website") {
          const result =  _.clone(websites);
          console.log(`result[${index}].label`, result[index].label);
          if(!result[index].label) {
            const linkLabel = new URL(e.target.value).hostname?.replace(/^www\./gi, "").split(".")[0];
            result[index].label = linkLabel;
          }
          setWebsites(result);
        }
        return;
      }
    };

  return (
    <div className="">
      <div className="w-full mt-15 3md:flex -mb-6">
        <div className="w-full mb-5 3md:w-6/20 3md:mb-0">
          <div className="w-full flex flex-row gap-x-2 items-center">
            <p className="text-lg text-lightBlack font-semibold">
              Social Media
            </p>
            <PopInfo
              containerClass="relative"
              type="social_media"
            />
          </div>
        </div>
        <div className="w-full 3md:w-14/20">
          <SocialSelect
            items={socials}
            errors={state.validationErrors}
            onAdd={onAddSocials}
            onChange={(e, index) => onTypeLinkSocial(e, index,'social')}
            onSelect={(e, index) => onSelectSocial(e, index)}
            onRemove={(index) => onRemoveSocials(index,'social')}
            onBlur={(e, index) => checkUrl(e, index, "social")}
          />
        </div>
      </div>

      {/* Profile types */}
      <div className="w-full mt-15 3md:flex -mb-6">
        <div className="w-full mb-5 3md:w-6/20 3md:mb-0">
          <div className="w-full flex flex-row gap-x-2 items-center">
            <p className="text-lg text-lightBlack font-semibold">{t("websites")}</p>
            <PopInfo
              containerClass="relative"
              type="website"
              responsive={{
                left: "125px",
                right: "125px",
              }}
            />
          </div>
        </div>
        {/* forms */}
        <div className="w-full 3md:w-14/20">
          <WebsiteSelect
            items={websites}
            errors={state.validationErrors}
            onAdd={onAddSocials}
            onChange={(e, index) => onTypeLinkSocial(e, index, "website")}
            onLabelChange={onLabelChange}
            onSelect={(e, index) => onSelectSocial(e, index)}
            onBlur={(e, index) => checkUrl(e, index, "website")}
            onRemove={(index) => onRemoveSocials(index, "website")}
            setItems={setWebsites}
          />
        </div>
      </div>
    </div>
  );
}
